export default __webpack_public_path__ + "static/media/b1.270cf320.svg";